














import { Component, Vue, Prop, Emit } from "vue-property-decorator";

@Component({
  name: "Two",
})
export default class Two extends Vue {
  @Prop({
    type: Array,
    default: [],
  })
  content!: Array<any>;
 @Prop({
    type: [String,Number],
    default: '',
  })
  id!: String;
 
  @Emit()
  public imageClick(item:any) {
    return item;
  }

  created() {
    // console.log("data===2=>", this.content);
  }
}
